/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * SMTP authentication settings
 * @export
 * @interface SmtpAuthentication
 */
export interface SmtpAuthentication {
    /**
     * 
     * @type {string}
     * @memberof SmtpAuthentication
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof SmtpAuthentication
     */
    password?: string;
}

/**
 * Check if a given object implements the SmtpAuthentication interface.
 */
export function instanceOfSmtpAuthentication(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmtpAuthenticationFromJSON(json: any): SmtpAuthentication {
    return SmtpAuthenticationFromJSONTyped(json, false);
}

export function SmtpAuthenticationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmtpAuthentication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function SmtpAuthenticationToJSON(value?: SmtpAuthentication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

